export const T = {
  en_GB: {
    settings: "Settings",
    title: "3rd party features",
    description:
      "Enable or disable the metered 3rd-party features available to your organization. Prices below are per usage and exclude VAT. Changes save automatically.",
    whereby: "Whereby video meetings",
    wherebyDesc: "Online client meetings with optional cloud recording and transcription.",
    fileTranscription: "File transcription",
    fileTranscriptionDesc:
      "Automatically extract text and summarise files uploaded to clients (PDFs, Office docs, images, audio). Document OCR runs on Mistral; audio transcription runs on Scaleway hosted Whisper Large (EU); summaries use the tenant's Simple Model.",
    webTools: "Web search & fetch",
    webToolsDesc: "Let AI agents search the web and fetch/scrape page content.",
    enin: "ENIN company lookup",
    eninDesc: "Look up Norwegian company data and financials by organisation number.",
    idura: "Idura — eID & e-signatures",
    iduraDesc:
      "BankID/MitID login and qualified e-signatures for flows, via Idura (formerly Criipto).",
    sinch: "SMS notifications",
    sinchDesc: "Outbound SMS for signature invites and one-time codes.",
  },
  nb_NO: {
    settings: "Innstillinger",
    title: "Tredjepartsfunksjoner",
    description:
      "Aktiver eller deaktiver de målte tredjepartsfunksjonene som er tilgjengelige for organisasjonen din. Prisene under er per bruk og ekskl. mva. Endringer lagres automatisk.",
    whereby: "Whereby videomøter",
    wherebyDesc: "Nettmøter med kunder, med valgfri skyopptak og transkripsjon.",
    fileTranscription: "Filtranskripsjon",
    fileTranscriptionDesc:
      "Trekk automatisk ut tekst og oppsummer filer som lastes opp til kunder (PDF-er, Office-dokumenter, bilder, lyd). Dokument-OCR kjører på Mistral; lydtranskripsjon kjører på Scaleway-hostet Whisper Large (EU); oppsummeringer bruker leietakerens enkle modell.",
    webTools: "Websøk og henting",
    webToolsDesc: "La AI-agenter søke på nettet og hente/skrape sideinnhold.",
    enin: "ENIN selskapsoppslag",
    eninDesc: "Slå opp norske selskapsdata og regnskapstall etter organisasjonsnummer.",
    idura: "Idura — eID og e-signaturer",
    iduraDesc:
      "BankID/MitID-pålogging og kvalifiserte e-signaturer for flyter, via Idura (tidligere Criipto).",
    sinch: "SMS-varsler",
    sinchDesc: "Utgående SMS for signeringsinvitasjoner og engangskoder.",
  },
} as const;
